import { render, staticRenderFns } from "./LeadModal.vue?vue&type=template&id=1dfa72a6&"
import script from "./LeadModal.vue?vue&type=script&lang=js&"
export * from "./LeadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports